import { render, staticRenderFns } from "./ItemFlex.vue?vue&type=template&id=42929e32&"
import script from "./ItemFlex.vue?vue&type=script&lang=js&"
export * from "./ItemFlex.vue?vue&type=script&lang=js&"
import style0 from "./ItemFlex.vue?vue&type=style&index=0&id=42929e32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports